import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BlurLoader from './BlurFullPageLoader';
import { copyToClipboard } from './EnvConfig';

const FinalView = ({ handleClear, loading, message = 'Thank you for your purchase! Your order[24225435] has been successfully processed.!', type }) => {
    const location = useLocation();
    let ProductCode = location?.pathname?.split('/')[2]?.replace(/%20/g, ' ') || '';
    const inputrefs = useRef([])
    const navigate = useNavigate()
    const [isFocused, setIsFocused] = useState(false);
    const [copyStatus, setCopyStatus] = useState(false)
    const handleNavigate = () => {
        handleClear()
        navigate(`/SaleEntry/${ProductCode}`)
    };

    useEffect(() => {
        if (copyStatus) {
            setTimeout(() => {
                setCopyStatus(false)
            }, 1000)
        }
    }, [copyStatus])

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    useEffect(() => {
        type !== 'Customer' &&
            inputrefs.current['boxNewEntry'].focus()
    }, [])

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="main-card rounded-0 p-4 d-flex flex-column justify-content-center" style={{ height: '72vh' }}>
                        <div className="d-flex align-items-center flex-column text-center">
                            <div className="success_icon d-flex justify-content-center align-items-center mb-3">
                                <img src='./images/thanku2.svg' alt='ICON' />
                            </div>
                            <p className='m-0 mb-1' style={{ fontSize: '14px', fontFamily: 'sans-serif', fontWeight: 600, lineHeight: '1.2' }}>

                                {message && (() => {
                                    const [beforeBrackets, rest] = message.split('[');
                                    if (!rest) return <>{message}</>;

                                    const [textToCopy, afterBrackets] = rest.split(']');
                                    if (!afterBrackets) return <>{message}</>;

                                    return (
                                        <>
                                            {`${beforeBrackets} [`}
                                            <Tooltip
                                                title={copyStatus ? 'Copied!' : 'Copy to clipboard!'}
                                                arrow
                                                componentsProps={{
                                                    arrow: { sx: { color: "#5D3FD3" } },
                                                    tooltip: { sx: { color: "white", backgroundColor: "#5D3FD3" } }
                                                }}
                                            >
                                                <span
                                                    style={{ color: '#799EDE', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setCopyStatus(true);
                                                        copyToClipboard(textToCopy.trim());
                                                    }}
                                                >
                                                    {textToCopy.trim()}
                                                </span>
                                            </Tooltip>
                                            {` ]${afterBrackets}`}
                                        </>
                                    );
                                })()}

                            </p>
                            <hr style={{
                                marginTop: "1rem",
                                marginBottom: "1rem",
                                borderWidth: "0",
                                borderTop: "1px solid #F5F5F5"
                            }}></hr>
                            {type !== 'Customer' &&
                                <>
                                    <div className="message_body">
                                        <h4 style={{ color: "#F1916D" }}>Choose Next Option</h4>
                                    </div>
                                    <div className="col-12 flex-row d-flex flex-wrap justify-content-center gap-3">
                                        <div className="d-flex flex-column justify-content-center  align-items-center px-4 finalBook"
                                            ref={ref => inputrefs.current['boxNewEntry'] = ref}
                                            style={{
                                                backgroundColor: "green", width: "150px", borderRadius: "4px", cursor: "pointer",
                                                boxShadow: isFocused && "2px 2px 8px #E05D4D"
                                            }}
                                            onClick={() => {
                                                handleNavigate(false)
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleNavigate(false)
                                                }
                                            }}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            tabIndex={0}
                                        >
                                            <IoMdAdd style={{ color: "white", fontSize: "23px", marginTop: "8px", fontWeight: "bolder" }} />
                                            <p style={{ color: "white", fontSize: "12px", fontWeight: 'bold' }}>NEW SALE ENTRY</p>
                                        </div>
                                    </div>
                                </>}
                        </div>
                    </div>
                </div>
            </div>
            {loading ? <BlurLoader /> : <></>}
        </>
    )
}
export default FinalView;